import { defineStore } from 'pinia';
import type { AnalyticsAttributesModel } from '@core/analytics/common/models/store.index.models';
import { FUNNEL_STATE_QUERY_KEY } from '@core/base/utils/funnelStateCode';

interface KegelAnalyticStateModel {
  userUuid: string
  userEmail: string
  analyticsAttributions: AnalyticsAttributesModel | null
  savedClickId: string
  attributesWasSet: boolean
  clickId: string
  clickTime: number
  sha256UserEmail: string
  userData: UserDataModel | object
  ageId: string
  cmpId: string
  currentExperimentKey: string
  currentExperimentVariation: string
  subscriptionInfo: SubscriptionModel | null
  goals: GoalsModel | null,
  versions: VersionsModel | null,
  isSuperDiscount: boolean,
  addGoal: boolean,
  startLevel: number
  funnelCode: string
  steps: number
  quiz: QuizAnswersStorageModel | object
  experiments: Array<{ experimentId: string, variation: string }>
  featureFlags: Record<string, string>
  isDisabledBaseDialog: boolean
  isLogRocketEnabled: boolean
  prePaywallWasShown: boolean
}

export const useKegelAnalyticStore = defineStore('kegelAnalytic', {
  state: (): KegelAnalyticStateModel => {
    return {
      userUuid: '',
      userEmail: '',
      sha256UserEmail: '',
      analyticsAttributions: null,
      savedClickId: '',
      attributesWasSet: false,
      clickId: '',
      clickTime: 0,
      userData: {},
      ageId: '',
      cmpId: '',
      currentExperimentKey: '',
      currentExperimentVariation: '',
      subscriptionInfo: null,
      goals: null,
      versions: null,
      isSuperDiscount: false,
      addGoal: false,
      startLevel: 0,
      funnelCode: '',
      steps: 3,
      quiz: {},
      experiments: [],
      featureFlags: {},
      isDisabledBaseDialog: false,
      isLogRocketEnabled: false,
      prePaywallWasShown: false,
    };
  },

  persist: {
    userEmail: {
      query: 'email',
      local: 'user_email',
    },
    userUuid: {
      query: ['uuid', 'user_uuid'],
      readOnly: true, // uuid.ts is the sole authority for writing
    },
    clickId: {
      query: 'rtkcid',
      readOnly: true, // getClickID() manages the full lifecycle
    },
    clickTime: {
      local: 'b_click_time',
    },
    currentExperimentKey: {
      query: 'experimentId',
    },
    currentExperimentVariation: {
      query: 'variation',
    },
    ageId: {
      local: 'age_id',
    },
    cmpId: {
      query: 'cmpid',
      local: 'cmp_id',
    },
    subscriptionInfo: {
      local: 'subscriptionInfo',
    },
    goals: {
      local: 'goals',
    },
    versions: {
      local: 'versions',
    },
    isSuperDiscount: {
      local: 'isSuperDiscount',
    },
    addGoal: {
      local: 'addGoal',
    },
    startLevel: {
      local: 'startLevel',
    },
    funnelCode: {
      query: FUNNEL_STATE_QUERY_KEY,
    },
    quiz: {
      local: 'quiz',
    },
    experiments: {
      local: 'experiments',
    },
    featureFlags: {
      local: 'featureFlags',
    },
    savedClickId: {
      local: 'savedClickId',
    },
    attributesWasSet: {
      local: 'attributesWasSet',
    },
    analyticsAttributions: {
      local: 'analyticsAttributions',
    },
    isLogRocketEnabled: {
      query: 'lr',
    },
    prePaywallWasShown: {
      local: 'prePaywallWasShown',
    },
  },
});
